
import Vue from 'vue'
import { route, authenticated, me } from '@/middleware/middleware'

export default Vue.extend({
  middleware: [route, authenticated, me],
  head(): any {
    const title = this.App.state.current?.title
    const titleTemplate = title ? '%s - ' + process.env.APPLICATION_NAME : null

    return {
      title,
      titleTemplate
    }
  },
  computed: {
    __bottom(): boolean {
      return this.App.state.bottom && this.$vuetify.breakpoint.mobile && !this.App.state.mobile
    },
    __drawer(): boolean {
      return !this.App.state.mobile
    },
    __style(): any {
      return { paddingTop: this.App.state.headerHeight }
    }
  },
  created() {
    this.App.state.layout = 'default'
  }
})
